module.exports = __webpack_public_path__ + "img/tractor-photo-04.4c20200c.jpeg";